import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

// Attach auth token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Force cache busting for all GET requests to prevent stale data
  if (config.method === 'get') {
    config.params = config.params || {};
    config.params._t = Date.now(); // Add timestamp to prevent caching
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
  }
  
  return config;
});

// Handle 401/403 errors by forcing re-authentication ONLY for actual auth failures
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only force logout for auth token issues, not permission issues
    if (error.response) {
      const status = error.response.status;
      const url = error.config?.url || '';
      
      // Check if this is an authentication failure (invalid/expired token)
      // vs an authorization failure (valid token but insufficient permissions)
      if (status === 401) {
        // 401 = Unauthorized = Invalid or expired token = Force logout
        console.error('[API] Authentication failed - token invalid/expired - clearing session');
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 403) {
        // 403 = Forbidden = Valid token but insufficient permissions = Show error, don't logout
        console.warn('[API] Permission denied for:', url);
        // Don't force logout - let the component handle the error
      }
    }
    
    return Promise.reject(error);
  }
);

// Re-export the base URL for cases that need it (e.g. window.open)
export const API_URL = `${API_BASE}/api`;

export default api;
